import Vue from 'vue';
import Vuex from 'vuex';
import config from '../config';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    language: {},
    connectorArguments: {},
    cache: {}, // Cache is clearable
    parameters: {}
  },
  getters: {
    getConnectorArguments: state => {
      return state.connectorArguments;
    },
    allCached: state => {
      return state.cache;
    },
    getCached: state => key => {
      return state.cache.find(o => (o ? o.key === key : null));
    }
  },
  mutations: {
    CACHE_VALUE: (state, data) => {
      Object.assign(state.cache, data);
    },
    SAVE_VALUE: (state, data) => {
      Object.assign(state.parameters, data);
    },
    SAVE_LANGUAGE: (state, data) => {
      Object.assign(state.language, data);
    },
    CLEAR_CACHE: state => {
      state.cache = {};
    }
  },
  actions: {
    CACHE_VALUE: function({ commit }, payload) {
      commit('CACHE_VALUE', payload);
    },
    SAVE_VALUE: function({ commit }, payload) {
      commit('SAVE_VALUE', payload);
    },
    SET_LANGUAGE: function({ commit }, lang) {
      commit('SAVE_LANGUAGE', lang);
    },
    CLEAR_CACHE: function({ commit }) {
      commit('CLEAR_CACHE');
    }
  },
  modules: {}
});
